import React from "react";
import Style from "./UserDetailCard.module.css";
import { userTypeHandler } from "../../../Utils/Helper/Helper";
import { useHistory } from "react-router-dom";
const UserDetailCard = ({ userData }) => {
    const history=useHistory()
  return (
    <section className={Style.CardHolder}>

        <div className={Style.userInfoHolder}>
          <div>
            <p>
                شناسه کاربر:
              <span>{userData?.id}</span>
            </p>
            <p>
                نام:
              <span>{` ${userData?.first_name} ${userData?.last_name}`}</span>
            </p>
            
          </div>
          <div>
            <p>
                نوع کاربری:
              <span>{userTypeHandler(userData?.user_type)}</span>
            </p>
            <button className={Style.transformButton} onClick={()=>history.push(`/wallet/transfer_to/${userData?.user_type}/${userData?.id}`)}>انتقال</button>
          </div>
        </div>
      
    </section>
  );
};

export default UserDetailCard;
